module.exports = __webpack_public_path__ + "img/柚子12.a79753f9.png";